import React, { useState, useEffect, memo } from "react";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import CustomButton from "../inputs/customButton";
import ImageModal from "components/images/Imagemodal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { getCookie } from "components/helper/cookies";
import { createTestimonial, testimonialDetails, updateTestimonial } from "api/car";
import { useNavigate } from "react-router-dom";
import { Skeleton } from 'antd';

function TestimonialForm({ handleLoader }) {
    const path = window.location.pathname.split("/")[2];
    const isNew = path === "new";
    const [loading, setLoading] = useState(!isNew);
    const [stateData, setStateData] = useState({
      en_title: "",
      ar_title: "",
      en_description: "",
      ar_description: "",
      profileImage: {},
      status: "active"
    });
    const [errors, setErrors] = useState({});
    const [showImageModal, setShowImageModal] = useState(false);
    const [language, setLanguage] = useState("en"); // Language state: "eng" or "ar"
    // const [imageType, setImageType] = useState("");
    let navigate = useNavigate();
  
    const fetchTestimonialDetails = () => {
      const path = window.location.pathname.split("/")[2];
      testimonialDetails(getCookie("auth_token"), path)
        .then((data) => {
          setStateData({
            en_title: data.data.en_title || "",
            ar_title: data.data.ar_title || "",
            en_description: data.data.en_description || "",
            ar_description: data.data.ar_description || "",
            profileImage: data.data.title_image || "",
            status: data.data.status || "active",
          });
          setLoading(false);
        })
        .catch((error) => {
          console.log(error, "error");
          toast.error("Failed to load testimonial details.");
          setLoading(false);
        });
    };
  
    useEffect(() => {
      if (!isNew) {
        setLoading(true);
        fetchTestimonialDetails();
      }
    }, [path, isNew]);
  
    const handleModel = () => {
      setShowImageModal(!showImageModal);
    };

    const handleStatus = (newStatus) => {    
      if (newStatus !== null) {
        setStateData((prevState) => ({ ...prevState, status: newStatus })); 
      }
    };

    // Handle language toggle (ENG/ARABIC)
    const handleLanguageChange = (newLanguage) => {
      if (newLanguage !== null) {
        setLanguage(newLanguage);
      }
    };
  
    const handleChange = (event) => {
      const { name, value } = event.target;
      setStateData((prevState) => ({ ...prevState, [name]: value }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };
  
    const onModalOk = (image_name) => {
      setStateData((prevState) => ({
        ...prevState,
        profileImage: image_name,
      }));
      setShowImageModal(false);
    };
  
    const validateFields = () => {
      const newErrors = {};
    
      if (!stateData.en_title.trim()) newErrors.en_title = "Title is required";
      if (!stateData.ar_title.trim()) newErrors.ar_title = "Title is required";
      if (!stateData.en_description.trim()) newErrors.en_description = "Description is required";
      if (!stateData.ar_description.trim()) newErrors.ar_description = "Description is required";
      if (!stateData.profileImage || !stateData.profileImage.id) newErrors.profileImage = "Profile Image is required";

      setErrors(newErrors);
      
      if (!stateData.profileImage || !stateData.profileImage.id) {
        toast.error("Please upload a Profile Image.");
        return false;
      }
    
      return Object.keys(newErrors).length === 0;
    };
  
    const handleSubmit = () => {
        if (!validateFields()) {
            return;
        }
    
        const requestBody = {
          testimonials: {
            en_title: stateData.en_title,
            ar_title: stateData.ar_title,
            en_description: stateData.en_description,
            ar_description: stateData.ar_description,
            title_image_id: stateData.profileImage.id,
            status: stateData.status,
          }
        };
    
        const path = window.location.pathname.split("/")[2];
        handleLoader(true);
        const testimonialAction = isNew ? createTestimonial : updateTestimonial;
    
        testimonialAction(getCookie("auth_token"), requestBody, path)
            .then(() => {
                toast.success(isNew ? "Testimonial created successfully!" : "Testimonial updated successfully!");
                navigate('/testimonial');
                handleLoader(false);
            })
            .catch((error) => {
                console.log(error, 'error');
                toast.error("Failed to submit testimonial.");
                handleLoader(false);
            });
    };
  
    if (loading) return <Skeleton />;
  
    return (
      <Paper elevation={0} style={{ backgroundColor: "rgb(244, 245, 250)" }}>
        <div style={{ padding: "1.25rem", display: "flex", justifyContent: "space-between" }}>
          <h2>{isNew ? "Create Testimonial" : "Update Testimonial"}</h2>
          <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
            <ToggleButtonGroup color="primary" name="language" exclusive onChange={(e, newLanguage) => handleLanguageChange(newLanguage)} value={language} style={{  }}>
              <ToggleButton value="en" style={{ width: "50px", height: "36px", padding: "6px 12px", backgroundColor: language === "en" ? "yellow" : "white", color: language === "en" ? "black" : "black" }}>EN</ToggleButton>
              <ToggleButton value="ar" style={{ width: "50px", height: "36px", padding: "6px 12px", backgroundColor: language === "ar" ? "red" : "white", color: language === "ar" ? "white" : "black" }}>AR</ToggleButton>
            </ToggleButtonGroup>
            <CustomButton color="success" onClick={handleSubmit} text={isNew ? "CREATE" : "UPDATE"} />
          </div>
        </div>
        <Divider />
        <div style={{ padding: "20px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label={language === "ar" ? "عنوان" : "Title"}
                variant="outlined"
                name={language === "en" ? "en_title" : "ar_title"}
                onChange={handleChange}
                value={language === "en" ? stateData.en_title : stateData.ar_title}
                fullWidth
                required
                error={(!!errors.en_title || !!errors.ar_title) && (language === "en" ? errors.en_title : errors.ar_title)}
                helperText={(!!errors.en_title || !!errors.ar_title) && (language === "en" ? errors.en_title : errors.ar_title)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={language === "ar" ? "وصف" : "Description"}
                variant="outlined"
                name={language === "en" ? "en_description" : "ar_description"}
                onChange={handleChange}
                value={language === "en" ? stateData.en_description : stateData.ar_description}
                fullWidth
                multiline
                rows={4}
                required
                error={(!!errors.en_description || !!errors.ar_description) && (language === "en" ? errors.en_description : errors.ar_description)}
                helperText={(!!errors.en_description || !!errors.ar_description) && (language === "en" ? errors.en_description : errors.ar_description)}
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ 
                display: "flex", 
                flexDirection: "row", 
                alignItems: "center", 
                gap: "20px" 
              }}>
                <div style={{ padding: "10px" }}>
                  <p style={{ 
                    fontFamily: "Inter, sans-serif", 
                    fontSize: "0.875rem", 
                    marginBottom: "5px" 
                  }}>
                    Status
                  </p>
                  <ToggleButtonGroup
                    value={stateData.status}
                    exclusive
                    onChange={(e, newStatus) => handleStatus(newStatus)}
                    color="primary"
                    name="status"
                  >
                    <ToggleButton value="active" style={{ width: "100px" }}>
                      Active
                    </ToggleButton>
                    <ToggleButton value="inactive" style={{ width: "100px" }}>
                      Inactive
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div style={{ padding: "10px" }}>
                <p style={{ 
                  fontFamily: "Inter, sans-serif", 
                  fontSize: "0.875rem", 
                  marginBottom: "5px" 
                }}>
                  Profile Image
                </p>
                {stateData.profileImage && stateData.profileImage.url ? (
                  <div style={{ 
                    position: "relative", 
                    width: "150px", 
                    height: "150px",  
                    borderRadius: "50%",
                    overflow: "hidden"
                  }}>
                    <img
                      style={{ 
                        width: "100%", 
                        height: "100%", 
                        objectFit: "cover"
                      }}
                      src={stateData.profileImage.url}
                      alt="Profile"
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "40px",
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={handleModel}
                    >
                      <Typography variant="body2" style={{ color: "white" }}>
                        Change
                      </Typography>
                    </div>
                  </div>
                ) : (
                  <CustomButton
                    text="Select Profile Image"
                    onClick={handleModel}
                  />
                )}
              </div>
            </Grid>
          </Grid>
        </div>
        {showImageModal && (
          <ImageModal
            showImageModal={showImageModal}
            handleModel={handleModel}
            onModalOk={onModalOk}
            multi={false}
            imageName="profileImage"
          />
        )}
        <ToastContainer style={{ zIndex: 999999 }} />
      </Paper>
    );
}

export default memo(TestimonialForm); 